import { render, staticRenderFns } from "./shipsoplist.vue?vue&type=template&id=2b0b8bff&scoped=true"
import script from "./shipsoplist.vue?vue&type=script&lang=js"
export * from "./shipsoplist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b8bff",
  null
  
)

export default component.exports